export default __webpack_public_path__ + "static/media/error500.f458bc62.svg";